import { NEWS } from '@/mocks/gossip';

const LABEL_STYLE: Record<string, string> = {
  实锤: 'bg-primary-100 text-primary-800',
  反转: 'bg-accent-100 text-accent-800',
  暗糖: 'bg-secondary-100 text-secondary-800',
  后续: 'bg-background-200 text-foreground-700',
  爆料: 'bg-accent-100 text-accent-800',
};

export default function Feed() {
  return (
    <section id="feed" className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
              <i className="ri-flashlight-fill text-primary-500" aria-hidden="true" />
              最新瓜讯 · 一刷到底
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              持续更新<b>婚内出轨实锤</b>与人物动态，来源、时间、热度一目了然。
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-1 rounded-full border border-background-300/70 bg-background-50 p-1">
            {['全部分类', '实锤', '疑云'].map((t) => (
              <button
                key={t}
                type="button"
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
                  t === '全部分类'
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-200'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {NEWS.map((n) => (
            <article
              key={n.id}
              className="group flex cursor-pointer flex-col rounded-xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between gap-2">
                <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-medium ${LABEL_STYLE[n.label]}`}>
                  {n.label}
                </span>
                <span className="flex items-center gap-0.5 text-xs font-bold text-primary-600">
                  <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                  {n.hot.toFixed(1)}°
                </span>
              </div>
              <h3 className="mt-3 text-[15px] font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-700">
                {n.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-xs leading-5 text-foreground-600">{n.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/60 pt-3">
                <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-news-line" aria-hidden="true" />
                    {n.source}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true" />
                    {n.time}
                  </span>
                </div>
                <i className="ri-arrow-right-line text-sm text-foreground-400 transition-all group-hover:translate-x-0.5 group-hover:text-primary-600" aria-hidden="true" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}